import { render, staticRenderFns } from "./FoldersEmpty.vue?vue&type=template&id=4e701598&scoped=true&"
import script from "./FoldersEmpty.vue?vue&type=script&lang=js&"
export * from "./FoldersEmpty.vue?vue&type=script&lang=js&"
import style0 from "./FoldersEmpty.vue?vue&type=style&index=0&id=4e701598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e701598",
  null
  
)

export default component.exports